import { useTranslation } from "react-i18next";
import SectionHeading from "./SectionHeading";
//import Button from "./ui/Button";
import { HeadingVariant, ButtonVariant } from "../types/constants";
import { useQuery } from "@tanstack/react-query";
import PartnersCardsBlock from "./PartnersCardsBlock";
import { partnersServiceFactory } from "../services/PartnersServiceImpl";
import { ALL_PAGES } from "./../constants";

const partnersService = partnersServiceFactory();

export default function PartnersSection() {
    const { t, i18n } = useTranslation();

    const { data: partners = [] } = useQuery({
        queryKey: ["partners", ALL_PAGES, i18n.language],
        queryFn: async () => {
            const { rows } = await partnersService.getAll(ALL_PAGES);
            return rows;
        },
    });

    if (!partners.length) return null;

    return (
        <section className="relative py-20 md:py-24 lg:py-28">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-screen h-full bg-background-100 -z-10" />

            <div className="mx-auto w-full lg:max-w-[1280px] flex flex-col">
                <SectionHeading text={t("home.headings.partners")} variant={HeadingVariant.DARK} />
                <PartnersCardsBlock partners={partners} />
                {/* 
                <div className="mt-6 w-full xl:w-auto">
                    <Button text={t("buttons.becomePartner")} variant={ButtonVariant.PRIMARY} />
                </div>
                */}
            </div>
        </section>
    );
}
